import React from 'react';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Switch from '../../../../shared/switch';
import Table from '../../../../shared/table';

const tableColumns = ['Name', 'Email', 'Username', 'Enabled', 'Actions']

interface IPartnersTable {
    rows: any;
    paginationData?: IPage;
    accessControl?: any;
    actions?: any;
    rowsLoading: boolean;
    onSeePartnerDetails: (id: any) => void;
    onEnableDisablePartner: (id: string, currentStatus: boolean) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onDeletePartnerRequest: (id: string) => void;
}

const PartnersTable = ({
    rows,
    paginationData,
    accessControl,
    actions,
    rowsLoading,
    setPaginationState,
    onDeletePartnerRequest,
    onEnableDisablePartner,
    onSeePartnerDetails
}: IPartnersTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.name}</td>
                                <td className='px-6 py-4'>{row?.email}</td>
                                <td className='px-6 py-4'>{row?.username}</td>
                                <td className='px-6 py-4'>
                                    <Switch
                                        checked={!!row?.enabled}
                                        onToggleSwitch={() => ((!accessControl || actions?.['Partner Enable Disable']) && row?._id) && onEnableDisablePartner(row?._id, row?.enabled || false)}
                                    />
                                </td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <div className='flex flex-row'>
                                        <div data-qa='partner-details' onClick={() => onSeePartnerDetails(row)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={`h-[14px] object-contain cursor-pointer mr-2`} />
                                        </div>
                                        <div data-qa='partner-delete' onClick={() =>  (row?._id) && onDeletePartnerRequest(row?._id)}>
                                            <img title={'Delete Partner'} alt='delete partner' src={'/assets/table-actions/delete-close.svg'} className={`h-[14px] object-contain cursor-pointer mr-2`} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default PartnersTable;